import {fabric} from 'fabric';
import {gifToSprite} from './GifToSprite';

const generateImage = ({dataUrl, delay, frameWidth, framesLength, imgOptions}) => {
  const [PLAY, PAUSE, STOP] = [0, 1, 2];

  return new Promise((resolve) => {
    fabric.Gif.fromURL(
      dataUrl,
      (img) => {
        const sprite = img.getElement();
        let framesIndex = 0;
        let start = performance.now();
        let status = PLAY;

        img.width = frameWidth;
        img.height = sprite.naturalHeight;
        img.mode = 'image';
        img.top = 0;
        img.left = 0;
        img.delay = delay;
        img.frameWidth = frameWidth;
        img.framesLength = framesLength;

        img._render = function (ctx) {
          if (status === PAUSE || (status === STOP && framesIndex === 0)) return;
          const now = performance.now();
          const delta = now - start;
          if (delta > delay) {
            start = now;
            framesIndex++;
          }
          if (framesIndex === framesLength || status === STOP) framesIndex = 0;
          ctx.drawImage(
            sprite,
            frameWidth * framesIndex,
            0,
            frameWidth,
            sprite.height,
            -this.width / 2,
            -this.height / 2,
            frameWidth,
            sprite.height
          );
        };
        img.play = function () {
          status = PLAY;
          this.dirty = true;
        };
        img.pause = function () {
          status = PAUSE;
          this.dirty = false;
        };
        img.stop = function () {
          status = STOP;
          this.dirty = false;
        };
        img.getStatus = () => ['Playing', 'Paused', 'Stopped'][status];

        img.play();
        resolve(img);
      },
      imgOptions
    );
  });
};

export const fabricGif = async (
  gif,
  imgOptions,
  maxWidth = null,
  maxHeight = null,
  maxDuration = null
) => {
  const {dataUrl, delay, frameWidth, framesLength} = await gifToSprite(
    gif,
    maxWidth,
    maxHeight,
    maxDuration
  );

  return generateImage({dataUrl, delay, frameWidth, framesLength, imgOptions});
};

export const fabricGifFromBase64 = async (dataUrl, delay, frameWidth, framesLength, imgOptions) =>
  generateImage({dataUrl, delay, frameWidth, framesLength, imgOptions});
